module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage2-2ef8fa79.jpeg";